
export class LinkLanguageConventionExtension {
    selected: boolean;
}
